import React, { useState } from "react";
import { Form, Input, InputNumber, Popconfirm, Table, Typography } from "antd";
import Loadingpage from "../../Components/Loadingpage/Loadingpage";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  let inputNode = inputType === "number" ? <InputNumber /> : <Input />;
  // console.log(dataIndex, 'dataIndex');

  // ✅ Make total/future_balance read-only (but still in form)
  if (dataIndex === "total") {
    inputNode = <Input disabled />;
  }

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
        // rules={
        //     dataIndex !== "future_balance"
        //         ? [{ required: true, message: `Please Input ${title}!` }]
        //         : []
        // }
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

// Main reusable component
const EditableTable = ({
  onChange,
  dataSource,
  columnsConfig,
  onSave,
  completeTrade,
  newValues,
  total,
  pageSize = 10,
  current,
  closeDisabled,
  loading,
}) => {
  const [form] = Form.useForm();

  const [data, setData] = useState(dataSource || []);
  const [editingKey, setEditingKey] = useState("");

  const isEditing = (record) => record.key === editingKey;

  const edit = (record) => {
    form.setFieldsValue({ ...record });
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey("");
  };

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      row.quantity = row.volume;
      // row.price = dataSource.find(item => item._id === key._id)?.price || 0;
      newValues({ ...row, _id: key._id });

      console.log(row, "row");

      cancel();

      // const newData = [...dataSource];
      // const index = newData.findIndex((item) => key === item.key);
      // console.log(newData,data, 'newData');
      // if (index > -1) {
      //     const item = newData[index];
      //     newData.splice(index, 1, { ...item, ...row });
      //     setData(newData);
      //     setEditingKey("");

      //     onSave?.(newData); // callback to parent
      // }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const mergedColumns = columnsConfig.map((col) => {
    if (!col.editable) return col;

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.inputType || "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing:
          isEditing(record) &&
          (typeof col.editable === "function"
            ? col.editable(record)
            : col.editable),
      }),
    };
  });

  // mergedColumns.push({
  //   title: "Operation",
  //   dataIndex: "operation",
  //   fixed: "right",
  //   render: (_, record) => {
  //     const editable = isEditing(record);
  //     return editable ? (
  //       <span>
  //         <Typography.Link
  //           onClick={() => { save(record) }}
  //           style={{ marginRight: 8 }}
  //         >
  //           Save
  //         </Typography.Link>
  //         <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
  //           <a>Cancel</a>
  //         </Popconfirm>
  //       </span>
  //     ) : (
  //       <div className={closeDisabled ? "display-3" : "display-1 Edcls-btn"}>
  //         <Typography.Link
  //           // disabled={record?.status !== 'init'}
  //           onClick={() => edit(record)}
  //         >
  //           Edit
  //         </Typography.Link>

  //         {!closeDisabled && <Popconfirm
  //           title="Are you sure you want to close this trade?"
  //           onConfirm={() => completeTrade(record)} // ✅ send trade id
  //         >
  //           <Typography.Link
  //           // disabled={record?.status !== 'init'}
  //           >
  //             Close
  //           </Typography.Link>
  //         </Popconfirm>}
  //       </div>
  //     );
  //   },
  // });

  return (
    <Form
      form={form}
      component={false}
      onValuesChange={(changed, allValues) => {
        if ("price" in changed || "volume" in changed) {
          const price = parseFloat(allValues.price) || 0;
          const qty = parseFloat(allValues.volume) || 0;
          form.setFieldsValue({
            total: price * qty, // update total internally
          });
          console.log("Changed:", changed, allValues);
          console.log("Updated Total:", qty, price, price * qty);
        }
      }}
      className="form-inp"
    >
      <Table
        className="table-clr"
        components={{ body: { cell: EditableCell } }}
        dataSource={dataSource} // ✅ use state instead of prop
        columns={mergedColumns}
        rowClassName="editable-row"
        bordered={true}
        pagination={{
          total,
          pageSize,
          current: current,
          showSizeChanger: false,
          showTotal: (total) => `Total ${total} items`,
          className: "pagination-clr",
        }}
        scroll={{
          x: "max-content", // horizontal scroll if many columns
        }}
        onChange={onChange}
        loading={{
          spinning: loading,
          indicator: <Loadingpage isLoading={loading} />, 
        }}      />
    </Form>
  );
};

export default EditableTable;
